/* if an anchor link is targeting a modal, show it */
$('a[href*="#"]').on('click', function (e) {
    var targetElementId = $(this).attr('href');

    //if the href is not a single character, such as the case with "#"
    if (targetElementId.length > 1) {
        var targetElement = $(targetElementId);

        if (targetElement) {
            if (targetElement.hasClass("modal")) {
                $(targetElement).modal('show');
            }
        }
    }
});

$('.modal.video-modal').on("show.bs.modal", function (event) {
    //pause all other YT videos (pause over stop because it'll be tracked by GTM)
    callYTPlayer('pauseVideo');
    //play the youtube video in the modal
    callYTPlayer('playVideo', $(this).find('iframe[src*="www.youtube.com"]'));
});

$('.modal.video-modal').on('hide.bs.modal', function () {
    //pause the video (pause over stop because it'll be tracked by GTM)
    callYTPlayer('pauseVideo', $(this).find('iframe[src*="www.youtube.com"]'));

    //reset the vimeo video
    $(this).find('iframe[src*=vimeo').attr("src", $(this).find("iframe").attr("src"));
})

$('.modal').on('hidden.bs.modal', function () {
    //var div = document.createElement("div");
    //div.id = $(this).find('iframe').attr('id');
    //div.setAttribute("data-video", '0pk3ejTOc6M');
    //$(this).find('iframe').replaceWith(div);
    //$(this).find("iframe").attr("src", $(this).find("iframe").attr("src"));

    //window.ytplayerList[0].stopVideo();
})